import React, { useCallback } from 'react'
import { Radio } from 'ic-snacks'
import { spacing } from '@retailer-platform/shared-components'
import { type PartnerPickDevicesFormData } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import {
  type DomainMessages,
  useDomainMessage,
} from 'domains/partner-pick-devices/utils/domain/intl'

interface PartnerPickDevicesFormRadioProps<T extends keyof PartnerPickDevicesFormData> {
  identifier: T
  labelMessageId: DomainMessages
  value: PartnerPickDevicesFormData[T]
  selectedValue: PartnerPickDevicesFormData[T]
  setValue: (value: PartnerPickDevicesFormData[T]) => void
  disabled?: boolean
}

export const PartnerPickDevicesFormRadio = <T extends keyof PartnerPickDevicesFormData>({
  identifier,
  labelMessageId,
  value,
  selectedValue,
  setValue,
  disabled,
}: PartnerPickDevicesFormRadioProps<T>) => {
  const label = useDomainMessage(labelMessageId)

  const onChange = useCallback(() => {
    setValue(value)
  }, [value, setValue])

  return (
    <Radio
      id={`${identifier}.${value}`}
      name={identifier}
      value={value}
      isSelected={value === selectedValue}
      onChange={onChange}
      style={{ wrapEl: { marginRight: spacing.X32 } }}
      isDisabled={disabled}
      data-testid={`${identifier}.${value}`}
    >
      {label}
    </Radio>
  )
}
